import { Component } from "react";
import { DataGrid, ptBR } from '@mui/x-data-grid';

export default class BasicDataGrid extends Component {
    render() {
        return (
            <DataGrid {...this.props.props} getRowId={(row) => row.uuid} sx={{
                mt: this.props.mt,
                "&.MuiDataGrid-root .MuiCircularProgress-root": {
                    color: 'primary.main'
                },
                "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                    outline: "none !important",
                },
                "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within": {
                    outline: "none !important",
                },
                "&.MuiDataGrid-root .MuiDataGrid-row": {
                    minHeight: this.props.dense ? '32px!important' : '48px!important',
                    cursor: this.props.props.onRowClick ? 'pointer' : 'unset',
                },
                "&.MuiDataGrid-root .MuiDataGrid-cell": {
                    minHeight: this.props.dense ? '32px!important' : '48px!important',
                },
                "&.MuiDataGrid-root .MuiDataGrid-footerContainer": {
                    minHeight: '32px!important',
                },
                "&.MuiDataGrid-root .MuiDataGrid-columnHeaders": {
                    bgcolor: 'mariano.terciary',
                },
                "&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitle": {
                    fontSize: 12,
                    fontWeight: 'bold',
                    color: 'primary.main'
                },
                "&.MuiDataGrid-root": {
                    border: 'unset',
                },
                "&.MuiDataGrid-root .MuiDataGrid-virtualScroller": {
                    overflowY: 'auto !important',
                    //maxHeight: { xs: 'calc(100vh - 350px) !important', sm: 'calc(100vh - 287px) !important'},
                    minHeight: 48,
                },
                ".lightYellow": {
                    bgcolor: '#fcf7d4',
                },
                ".lightRed": {
                    bgcolor: '#fcbbbb',
                }
            }}
                initialState={{
                    pagination: { paginationModel: { pageSize: 30 } },
                }}
                rows={this.props.rows} columns={this.props.columns}
                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                pageSizeOptions={[30, 60, 100]}
                disableColumnMenu
                disableRowSelectionOnClick
                density="compact"
                // autoHeight
                hideFooter={this.props.hideFooter === true}
                getRowHeight={() => 'auto'} />
        );
    }
}